import { StarterKit } from '@tiptap/starter-kit';
const INLINE_DISABLED = {
    heading: false,
    bulletList: false,
    orderedList: false,
    listItem: false,
    blockquote: false,
    codeBlock: false,
    horizontalRule: false,
    underline: false,
};
export function getRichTextExtensions(variant = 'full') {
    return [
        StarterKit.configure({
            link: { openOnClick: false },
            // only h2-h4 are supported; restrict the schema so h1/h5/h6 can't enter
            // via `# ` shortcut or paste (they fall back to paragraphs)
            heading: { levels: [2, 3, 4] },
            ...(variant === 'inline' ? INLINE_DISABLED : {}),
        }),
    ];
}
